/* globals $: true, Codsec: true, executeGet: true */

this.Codsec = this.Codsec || {};

this.Codsec.reloader = {
	_appReloadTimeout        : null,
	_scanResultReloadTimeout : null,
	_scanReloadUrl         : null,
	reloadApps : function(previousApps) {
		var self = this;

		if(this._appReloadTimeout) {
			clearTimeout(this._appReloadTimeout);
		}

		executeGet('/user/apps?useIgnore=1')
			.done(function(apps) {
				if(self._hasPendingItems(apps)) {
					self._appReloadTimeout = setTimeout(self.reloadApps.bind(self, apps), 10000);
				}

				//easiest way for object comparision
				var different = JSON.stringify(apps) !== JSON.stringify(previousApps);

				if(different) {
					Codsec.appList.destroyCarousel();
					$('#showAllApps-count').text(apps.length);
					$('#app-list-container').html(Codsec.templates.dashboard.appList({
						apps : apps
					}));
					Codsec.appList.reinitCarousel();
				}
			});
	},
	reloadScans : function(url, viewOptions) {
		var self = this;

		if(this._scanResultReloadTimeout) {
			clearTimeout(this._scanResultReloadTimeout);
		}

		this._scanReloadUrl = url;

		executeGet(url)
			.done(function(results) {
				//in case if user clicks around while results are being loaded
				if(url !== self._scanReloadUrl) {
					return;
				}

				var scans = results.results,
					hasPendingScans = self._hasPendingItems(scans);

				if(hasPendingScans) {
					self._scanResultReloadTimeout = setTimeout(
						self.reloadScans.bind(self, url, viewOptions), 10000);
				}

				viewOptions.scans = scans;

				var newHTML = Codsec.templates.dashboard.scanResults(viewOptions),
					oldHTML = $('#result-container').html();

				if(newHTML !== oldHTML) {
					$('#result-container').html(newHTML);
				}

			});
	},

	mightReloadScans : function(scans, url, viewOptions) {
		if(!this._hasPendingItems(scans)) {
			return;
		}

		this.reloadScans(url, viewOptions);
	},

	_hasPendingItems : function(scans) {
		for(var i = 0, l = scans.length; i < l; i++) {
			if(scans[i].status !== 'completed' && scans[i].status !== 'failed') {
				return true;
			}
		}

		return false;
	}
};
